<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { formsApi } from '@/services/api/forms';
import { useNotifier } from '@/composables/notifier';

const route = useRoute();
const router = useRouter();
const notify = useNotifier();
const status = ref<'cloning' | 'done' | 'error'>('cloning');

function ids(): { projectId: string; formId: string } {
  const p = route.params.id;
  const f = route.params.form ?? route.params.form_id;
  return {
    projectId: Array.isArray(p) ? (p[0] ?? '') : p ?? '',
    formId: Array.isArray(f) ? (f[0] ?? '') : f ?? '',
  };
}

onMounted(async () => {
  const { projectId, formId } = ids();
  try {
    const cloned = await formsApi.clone(projectId, formId);
    notify.success('Form cloned');
    status.value = 'done';
    await router.replace({
      name: 'projectFormEdit',
      params: { id: projectId, form_id: String(cloned.id) },
    });
  } catch {
    status.value = 'error';
    notify.error('Failed to clone form');
  }
});
</script>

<template>
  <section class="resource">
    <p v-if="status === 'cloning'">Cloning form…</p>
    <p v-else-if="status === 'error'">Failed to clone form.</p>
    <p v-else>Done. Redirecting…</p>
  </section>
</template>

<style scoped src="@/assets/styles/resource-list.scss"></style>
